import React from "react";
import Morgage from "@icons-rf/shortcut/morgage.svg?react";
import UserPlus from "@icons-rf/shortcut/user-plus.svg?react";
import PlusIcon from "@icons-rf/shortcut/plus-maxcore.svg?react";
import Comission from "@icons-rf/shortcut/comission.svg?react";
import { Link, useLocation } from "react-router-dom";
import { C_PATH_ROUTER } from "../../../model/const/path.const";
import { Tooltip, Box } from "@mui/material";
import useUserIs from "../../../hooks/use-useris.hook";
import { ERolesCode } from "@/shared/models/enums/roles/roles-code.enum";
import { IconPlus } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";
import { useWidth } from "@/shared/hooks/use-width.hook";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";

interface ShortcutItem {
  Route: string | null;
  Icon: React.ReactElement;
  show: boolean;
  msg: string;
  onClick?: () => void;
}

function ShortCut() {
  const { userIs } = useUserIs();
  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);
  const { guardReadOnlyAction } = useReadOnlyModeGuard();
  const { pathname } = useLocation();
  const handleBlockedAction = (actionName: string) => () => {
    guardReadOnlyAction(actionName, "shortcut");
  };

  // Ocultar botón de creación en rutas de creación y borradores
  const HIDE_CREATE_REGEXES = [
    // /realestates/create
    new RegExp(
      `^${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.CREATE}$`
    ),
    // /realestates/project/create
    new RegExp(
      `^${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.PROJECT_CREATE}$`
    ),
    // // /realestates/drafts
    // new RegExp(
    //   `^${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.PROPERTIES.DRAFT_LIST}$`
    // ),
    // /realestates/borrador/:idDraft/editar
    new RegExp(
      `^${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.PROPERTIES.DRAFT_UPDATE.replace(":idDraft", "[^/]+")}$`
    ),
    // /realestates/project/borrador/:idDraft/editar
    new RegExp(
      `^${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.PROPERTIES.DRAFT_PROJECT_UPDATE.replace(
        ":idDraft",
        "[^/]+"
      )}$`
    )
  ];
  const hideCreateButtons = HIDE_CREATE_REGEXES.some(rx => rx.test(pathname));
  const ITEMS: ShortcutItem[] = [
    {
      Route: null,
      Icon: (
        <MxButton2
          id="create-property-modal-shortcut-button"
          startIcon={
            <MxIcons size={16}>
              <IconPlus style={{ color: "white" }} size={16} />
            </MxIcons>
          }
          textColor="white"
          children="Crear inmueble"
          onClick={handleBlockedAction("crear inmueble")}
          variant="contained"
        />
      ),
      onClick: handleBlockedAction("crear inmueble"),
      show: !isMobile && !hideCreateButtons,
      msg: "Crear inmueble"
    },
    {
      Route: null,
      Icon: (
        <MxIcons
          onClick={handleBlockedAction("crear inmueble")}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "3px"
          }}
          size={isMobile ? 28 : 32}
        >
          <PlusIcon />
        </MxIcons>
      ),
      onClick: handleBlockedAction("crear inmueble"),
      show: isMobile && !hideCreateButtons,
      msg: "Crear inmueble"
    },
    {
      Route: null,
      Icon: <UserPlus />,
      onClick: handleBlockedAction("crear agente"),
      show: userIs(ERolesCode.SUPER_ADMIN, ERolesCode.ADMIN),
      msg: "Creación de agente"
    },
    {
      Route: null,
      Icon: <Comission />,
      onClick: handleBlockedAction("reportar comisión"),
      show: true,
      msg: "Reporte de comisiones"
    },
    {
      Route: null,
      Icon: <Morgage />,
      onClick: handleBlockedAction("crear referimiento hipotecario"),
      show: true,
      msg: "Referimiento hipotecario"
    }
  ].filter(item => item.show);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        marginRight: "1.2rem",
        "& svg": {
          width: { xs: "25px", sm: "30px" },
          height: { xs: "25px", sm: "30px" },
          fill: "var(--m-color-blue-03)",
          color: "var(--m-color-blue-03)",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            fill: "var(--m-color-blue-03)"
          }
        }
      }}
    >
      {ITEMS.map((item, index) => (
        <Tooltip title={item.msg} key={item.Route || index}>
          {!item.Route ? (
            <>{React.cloneElement(item.Icon as any, { onClick: item.onClick })}</>
          ) : (
            <Link to={item.Route} key={item.Route}>
              {React.cloneElement(item.Icon as any, {})}
            </Link>
          )}
        </Tooltip>
      ))}
    </Box>
  );
}

export default ShortCut;
